import { Component, OnInit, Inject, PLATFORM_ID, signal, WritableSignal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AppButtonsComponent } from '@shared/ui/app-buttons/app-buttons';
import { BUTTON_CLASS_TYPES } from '../../constants/app-button.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { ROUTES } from '@shared/constants/routes';
import { ROLES } from '@constants/role.constants';
import { AuthService } from '@shared/services/auth.service';
import { UserLogged } from '@shared/models/user';
import { ProfileService } from '@shared/services/profile.service';
import { EntityTypes } from 'app/core/models/general-entity.types';

@Component({
  selector: 'app-header',
  imports: [TranslatePipe, AppButtonsComponent],
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
})
export class Header implements OnInit {
  protected readonly BUTTON_CLASS_TYPES = BUTTON_CLASS_TYPES;
  svgContent = signal<SafeHtml | null>(null);
  menuOpen = false;
  user!: WritableSignal<UserLogged | null>;
  entity: EntityTypes = ROLES.CANDIDATE;
  getProfileImageUrl!: () => string;
  ROUTES = ROUTES;
  selectedRoute = signal(ROUTES.HOME);
  role: EntityTypes | null = null;
  
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID)
    private platformId: Object,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private authService: AuthService,
    private route: ActivatedRoute,
    private profileService: ProfileService
  ) {}

  ngOnInit() {
    this.user = this.authService.user;
    this.role = this.authService.getRole();
    
    this.http.get('assets/image/grens-find.svg', { responseType: 'text' }).subscribe((svg) => {
      const svgWithClass = svg.replace(
        '<svg',
        '<svg class="header-svg" style="width:139px;height:49px;"'
      );
      this.svgContent.set(this.sanitizer.bypassSecurityTrustHtml(svgWithClass));
    });
    this.getProfileImageUrl = this.profileService.getProfileImageUrl(
      this.role || ROLES.CANDIDATE
    );
    const currentRoute = this.router.url
      .replace(ROUTES.CANDIDATE_LOGGED_HOME, '')
      .replace(ROUTES.EMPLOYER_LOGGED_HOME, '')
      .split('/');
    if (currentRoute.length > 0) {
      this.selectedRoute.set(currentRoute?.at(-1) ?? ROUTES.HOME);
    }
  }

  showAlert(text: string) {
    console.log('text', text);
  }

  onSubmit(): void {
    console.log('Bottone cliccato!');
  }

  goTo(path: string) {
    console.log('path', path);
    this.router.navigateByUrl(`/${path}`);
  }

  getLinkHome() {
    if (this.authService.isLoggedIn()) {
      return this.user()?.user?.role === ROLES.EMPLOYER
        ? ROUTES.EMPLOYER_LOGGED_HOME
        : ROUTES.CANDIDATE_LOGGED_HOME;
    }
    return ROUTES.HOME;
  }

  onAdd() {
    this.router.navigate([ROUTES.CREATE_OPPORTUNITY], { relativeTo: this.route });
  }

  onClickProfile() {
    this.router.navigate([ROUTES.PROFILE], { relativeTo: this.route });
  }

  onClickHome() {
    this.selectedRoute.set(ROUTES.HOME);
    this.router.navigate([this.getLinkHome()]);
  }

  onYourAds() {
    this.selectedRoute.set(ROUTES.YOURS_OPPORTUNITIES);
    this.router.navigate([ROUTES.YOURS_OPPORTUNITIES], { relativeTo: this.route });
  }

  getBtnClassSelected(expectedUrl: string) {
    if (this.selectedRoute() === expectedUrl) {
      return BUTTON_CLASS_TYPES.PRIMARY;
    }
    return BUTTON_CLASS_TYPES.TERTIARY;
  }

  onClickMessages() {
    this.selectedRoute.set(ROUTES.MESSAGES);
    const basePath =
      this.user()?.user?.role === ROLES.EMPLOYER
        ? ROUTES.EMPLOYER_LOGGED_HOME
        : ROUTES.CANDIDATE_LOGGED_HOME;
    this.router.navigate([basePath, ROUTES.MESSAGES]);
  }

  onClickDashboard() {
    this.selectedRoute.set(ROUTES.DASHBOARD);
    const basePath =
      this.role === ROLES.EMPLOYER
        ? ROUTES.EMPLOYER_LOGGED_HOME
        : ROUTES.CANDIDATE_LOGGED_HOME;
    
    this.router.navigate([basePath, ROUTES.DASHBOARD]);
  }
}
